import type { StyledProps } from '@compiled/react';
import { styled } from '@compiled/react';
import type { ComponentType, ClassAttributes, HTMLAttributes, LiHTMLAttributes } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const UserListContainer: ComponentType<
	ClassAttributes<HTMLUListElement> & HTMLAttributes<HTMLUListElement> & StyledProps
> =
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
	styled.ul({
		listStyleType: 'none',
		listStylePosition: 'inside',
		display: 'flex',
		flexDirection: 'column',
		margin: '0px',
		padding: '0px',
	});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const UserListRow: ComponentType<
	ClassAttributes<HTMLLIElement> & LiHTMLAttributes<HTMLLIElement> & StyledProps
> =
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
	styled.li({
		margin: '0px',
		padding: '0px',
	});
